module.exports = __webpack_public_path__ + "KhushiNileshPathak-8fcdb0d5.png";